import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Header from 'components/Header';
import Home from 'pages/Home';
import SuperAgent from 'pages/SuperAgent';
import DataEngineering from 'pages/DataEngineering';
import Footer from 'components/Footer';
import ScrollRocket from 'components/ScrollRocket';

const AppContent = () => {
  const location = useLocation();
  const isServicePage =
    location.pathname === '/super-agent' ||
    location.pathname === '/data-engineering';

  const isDarkHero = location.pathname === '/data-engineering';

  return (
    <>
      <Header darkPage={isDarkHero} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/super-agent" element={<SuperAgent />} />
        <Route path="/data-engineering" element={<DataEngineering />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isServicePage && <ScrollRocket />}
      <Footer />
    </>
  );
};

const App = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
